import { render } from "./Slidesview_cn.vue?vue&type=template&id=7c81c611&scoped=true"
import script from "./Slidesview_cn.vue?vue&type=script&lang=js"
export * from "./Slidesview_cn.vue?vue&type=script&lang=js"

import "@/assets/css/globalcn.css?vue&type=style&index=0&id=7c81c611&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c81c611"]])

export default __exports__